"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.XDAI_WSS_ENDPOINT = exports.DEFAULT_IPFS_GATEWAY = void 0;
exports.DEFAULT_IPFS_GATEWAY = 'https://ipfs.eth.aragon.network';
exports.XDAI_WSS_ENDPOINT = 'wss://xdai.poanetwork.dev/wss';
//# sourceMappingURL=params.js.map